module.exports = __webpack_public_path__ + "static/media/LY.611f8bb2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/LY.svg
// module id = 306
// module chunks = 0